<template>
  <div>
    <site-header>
      <h1>Commercials</h1>
    </site-header>

    <main :class="$style.commercials" class="wrap">
      <p v-if="!this.loading" :class="$style.lede">I have carried out sound design duties on numerous commercials and promos. Some of the brands I've worked with are shown below.</p>
      <article :class="$style.logos">
        <div v-for="item in brands">
          <img :src="item.acf.logo.sizes.large">
        </div>
      </article>
    </main>

    <loader v-if="this.loading"></loader>
  </div>
</template>

<script>
  import axios from 'axios';
  import SiteHeader from '../components/SiteHeader';
  import Loader from '../components/Loader';

  export default {
    name: 'commercials',

    components: {
      SiteHeader,
      Loader,
    },

    head: {
      title() {
        return {
          inner: 'Commercials',
        };
      },
    },

    data() {
      return {
        loading: true,
        brands: [],
      };
    },

    mounted() {
      axios.get('/api/commercials').then((response) => {
        if (response.data) {
          this.loading = false;
          this.brands = response.data;
        }
      });
    },
  };
</script>

<style module lang="postcss">
  .commercials {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-right: 1rem;
    padding-bottom: 2rem;
    padding-left: 1rem;
    max-width: 62.5em;

    @media (width >= 50em) {
      padding-right: 4rem;
      padding-left: 4rem;
    }
  }

  .lede {
    font-size: 1.25rem;
  }

  .logos {
    display: flex;
    flex-wrap: wrap;
    margin-top: 2rem;
    margin-left: -1rem;

    & > div {
      display: inline-flex;
      align-items: center;
      margin-bottom: 1rem;
      padding-left: 1rem;
      width: 50%;
      height: auto;

      @media (width >= 50em) {
        margin-bottom: 2rem;
        width: 25%;
      }
    }

    & img {
      width: 100%;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// Commercials.vue?6653a213